/**
 * CustomDataGridDesktop Component
 *
 * Desktop version of the data grid using React Admin's Datagrid.
 * Provides a traditional table layout with sorting and row click support.
 */

import React from 'react';
import { Datagrid, DatagridProps, RaRecord } from 'react-admin';

interface CustomDataGridDesktopProps<RecordType extends RaRecord = any>
  extends DatagridProps<RecordType> {
  children: React.ReactNode;
}

const CustomDataGridDesktop = <RecordType extends RaRecord = any>({
  children,
  expand,
  bulkActionButtons,
  sx,
  ...props
}: CustomDataGridDesktopProps<RecordType>) => {
  return (
    <Datagrid
      {...props}
      expand={expand}
      bulkActionButtons={bulkActionButtons ?? false}
      rowClick={expand ? 'expand' : 'show'}
      sx={[
        {
          '& .RaDatagrid-headerCell': {
            fontWeight: 600,
          },
          '& .RaDatagrid-row': {
            cursor: 'pointer',
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Datagrid>
  );
};

export default CustomDataGridDesktop;
